module.exports = __webpack_public_path__ + "static/navbar_logo-804957a4c9768b00e2ac4344d2851dae.svg";